import './style.scss';
import type { Discount } from '@types';
import { Loader } from '@components/common/Loader';
import { ProductItem } from '@components/ProductList/components/ProductItem';
import { ErrorNotifications } from '@components/ErrorNotifications';

import { Product, UnavailableProduct } from '@types';

interface ProductListProps {
  isLoading: boolean;
  isFreeTrial: boolean;
  products: Product[];
  currency: string;
  discounts: Discount[];
  marketRestrictedProducts: UnavailableProduct[];
  onRemove: (uid: string) => () => void;
  onQuantityChange: (uid: string) => (qnt: number) => void;
}

const ProductList = (props: ProductListProps) => {
  if (props.isLoading) return <Loader />;

  return (
    <>
      <ErrorNotifications />
      <ul>
        {props.products.map((product) => (
          <ProductItem
            key={product.uid}
            product={product}
            currency={props.currency}
            isFreeTrial={props.isFreeTrial}
            onRemove={props.onRemove(product.uid)}
            onQuantityChange={props.onQuantityChange(product.uid)}
            discount={props.discounts.find((d) => d.itemNumber === product.biiId)}
            isRestrictedProduct={props.marketRestrictedProducts.some((p) => p.uid === product.salableUid)}
            restrictionReason={props.marketRestrictedProducts.find((p) => p.uid === product.salableUid)?.reason}
          />
        ))}
      </ul>
    </>
  );
};

export { ProductList };
